import styles from "./ServiceOfferingsLabels.module.css";

interface ChildProps {
  headerText: string;
  subText?: string;
  icon: React.ReactNode;
  onClick?: () => void;
  dropDown?: boolean;
  selected?: boolean;
  route?: any;
  locatorSubText?: string;
}

const ServiceOfferingsLabels = ({
  headerText,
  subText,
  icon,
  dropDown,
  onClick,
  selected,
  route,
  locatorSubText,
}: React.PropsWithChildren<ChildProps>) => {
  return (
    <div
      onClick={onClick}
      className={`${styles.wrapper} ${
        selected ? `${styles.wrapperSelected}` : `${styles.notSelected}`
      } `}
    >
      <div className={styles.mainContent}>
        <div className={styles.iconWrapper}>{icon}</div>
        <div
          className={
            subText ? `${styles.headerText}` : `${styles.headerTextMargin}`
          }
        >
          <h1>{headerText}</h1>
          <p>{subText}</p>
          <small className={locatorSubText ? `${styles.locatorSubText}` : `}`}>
            {locatorSubText}
          </small>
        </div>
      </div>
      {dropDown && (
        <img src="/images/svg/dropDownIcon.svg" alt="dropdown-icon" />
      )}
    </div>
  );
};

export default ServiceOfferingsLabels;
